module.exports = __webpack_public_path__ + "assets/img/office.jpeg";


//////////////////
// WEBPACK FOOTER
// ./resources/src/assets/img/office.jpeg
// module id = 33
// module chunks = 0